// src/utils/constants.js
export const NAVIGATION_LINKS = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Programs', path: '/programs' },
    { name: 'Events', path: '/events' },
    { name: 'Success Stories', path: '/success-stories' },
    { name: 'Resources', path: '/resources' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' },
  ];
  
  export const SOCIAL_LINKS = [
    { name: 'Facebook', url: 'https://www.facebook.com/LeoTECH2021.1', icon: 'facebook' },
    { name: 'LinkedIn', url: 'https://www.linkedin.com/company/leotech-sl-ltd', icon: 'linkedin' },
    { name: 'YouTube', url: 'https://youtube.com/@leotechsl', icon: 'youtube' },
  ];
  
  export const PROGRAMS = [
    {
      id: 'bim',
      title: 'Building Information Modeling',
      shortDesc: 'Learn Revit Architecture, Chief Architect, AutoCAD, and Lumion for modern building design',
      icon: 'building',
      features: [
        'Revit Architecture',
        'Chief Architect',
        'AutoCAD',
        'Lumion'
      ],
      category: 'design'
    },
    {
      id: 'cad',
      title: 'Computer-Aided Design',
      shortDesc: 'Master AutoCAD, Fusion360, and Autodesk Inventor for precision engineering design',
      icon: 'pencil-ruler',
      features: [
        'AutoCAD',
        'Fusion360',
        'Autodesk Inventor'
      ],
      category: 'design'
    },
    {
      id: 'survey',
      title: 'Land Survey & Photogrammetry',
      shortDesc: 'Use Global Mapper, GIS, Drones and other equipment for accurate land surveying',
      icon: 'map',
      features: [
        'Global Mapper',
        'GIS',
        'Drone Operation',
        'Equipment Handling'
      ],
      category: 'geospatial'
    },
    {
      id: 'ict',
      title: 'Basic ICT Skills',
      shortDesc: 'Develop proficiency in Graphics Design using Photoshop and Microsoft Office applications',
      icon: 'desktop',
      features: [
        'Photoshop',
        'Microsoft Office',
        'Digital Literacy'
      ],
      category: 'general'
    },
    {
      id: 'programming',
      title: 'Computer Programming',
      shortDesc: 'Learn Python, C/C++, JavaScript, and WordPress for web and software development',
      icon: 'code',
      features: [
        'Python',
        'C/C++',
        'JavaScript',
        'WordPress'
      ],
      category: 'development'
    }
  ];
  
  export const COMPANY_INFO = {
    name: 'Leotech (SL) Limited',
    motto: 'Skills Against Poverty',
    established: 'November, 2020',
    registrationDate: 'January 19, 2021',
    focus: 'Empowering Youths with Advanced Marketable Digital Skills and Foster Research and Innovation',
    contact: {
      address: 'Freetown, Sierra Leone',
      email: 'info@leotechsl.com',
      phone: '+232 79727380'
    },
    website: 'www.leotechsl.com'
  };
  
  
  
  